var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNothingHere(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105 50.4286V55.0286C104.994 65.8107 101.502 76.302 95.0466 84.9377C88.5908 93.5735 79.5164 99.891 69.1768 102.948C58.8371 106.005 47.7863 105.638 37.6723 101.902C27.5584 98.1649 18.9233 91.2591 13.0548 82.2139C7.18633 73.1688 4.39896 62.4689 5.10838 51.7102C5.81781 40.9514 9.98603 30.7102 16.9914 22.514C23.9968 14.3177 33.4639 8.60553 43.9809 6.22935C54.498 3.85317 65.5013 4.9403 75.35 9.32862M105 15.0286L55 65.0786L40 50.0786",
    stroke: "#EEF7FE",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingHere);
export default "data:image/svg+xml,%3csvg width='110' height='110' viewBox='0 0 110 110' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M105 50.4286V55.0286C104.994 65.8107 101.502 76.302 95.0466 84.9377C88.5908 93.5735 79.5164 99.891 69.1768 102.948C58.8371 106.005 47.7863 105.638 37.6723 101.902C27.5584 98.1649 18.9233 91.2591 13.0548 82.2139C7.18633 73.1688 4.39896 62.4689 5.10838 51.7102C5.81781 40.9514 9.98603 30.7102 16.9914 22.514C23.9968 14.3177 33.4639 8.60553 43.9809 6.22935C54.498 3.85317 65.5013 4.9403 75.35 9.32862M105 15.0286L55 65.0786L40 50.0786' stroke='%23EEF7FE' stroke-width='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };